import { Shark } from "shark-mvc";
// import { NousCore } from "nouscore-js-api";

import ManagerBase from "./ManagerBase";

class TextContentManager extends ManagerBase {
	constructor () {
		super("textContentManager");
		this.remoteClassName = "text-content";
	}
}

const textContentManager = new TextContentManager();

Shark.registerController(textContentManager);

export default textContentManager;
